const globalhelper = {
  getBearerToken: function () {
    if (localStorage.getItem('authorization')) {
      let loginData = localStorage.getItem('authorization')
      let AuthStr = 'Bearer ' + loginData
      return AuthStr
    } else {
      return ''
    }
  },
  isAuthendicated: function () {
    if (localStorage.getItem('loggin_data')) {
      return true
    } else {
      return false
    }
  },
  getBaseURI: function () {
    return 'http://localhost:8080api/'
  },
  getTimestamp: function (key) {
    let newDate = new Date()
    let date = newDate.getDate()
    let month = newDate.getMonth() + 1
    let year = newDate.getFullYear()
    return key === 'year' ? year : key === 'month' ? month : ''
  },
  currencyFormatter: function (value) {
    if (!value) {
      value = 0
    }
    if (typeof value === 'string') {
      value = Number(value)
    }
    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    })
    return formatter.format(value)
  },
  reload: function () {
    setTimeout(() => {
      window.location.reload()
    }, 500)
  },
  sanitizeText: function (text = '') {
    let sanitizedText = `${text}`
    if (
      sanitizedText.indexOf('@') > -1 ||
      sanitizedText.indexOf('=') > -1 ||
      sanitizedText.indexOf('+') > -1 ||
      sanitizedText.indexOf('-') > -1
    ) {
      sanitizedText = `'${sanitizedText}`
    }
    return sanitizedText
  },
  debounce: function (func, wait = 300) {
    let timeout
    return function (...args) {
      const context = this
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(context, args), wait)
    }
  },
  roundOff: function (num, precision = 2) {
    if (isNaN(num) || num === null || num === undefined) {
      return 0
    }
    const factor = Math.pow(10, precision)
    return Math.round(Number(num) * factor) / factor
  },
  stringToColor: function (string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  }
}

export default globalhelper
